import { Component, HostListener, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from 'src/app/guards/pending-changes.guard';
import { MeetingRecordComponent } from '../../../../meeting-record/meeting-record.component';

@Component({
  selector: 'app-company-product-meeting-record-credit',
  templateUrl: './company-product-meeting-record-credit.component.html',
  styleUrls: ['./company-product-meeting-record-credit.component.css', '../../../../meeting-record/meeting-record-parent-shell.styles.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MeetingRecordComponent],
})
export class CompanyProductMeetingRecordCreditComponent implements OnInit, ComponentCanDeactivate {
  protected activatedRoute = inject(ActivatedRoute);

  @ViewChild(MeetingRecordComponent) childComponent: MeetingRecordComponent;
  meetingableType: 'App\\Models\\User' | 'App\\Models\\CompanyProduct' | 'App\\Models\\PotentialClient' = 'App\\Models\\CompanyProduct';
  meetingableId: number;
  meetingRecordId: number;

  constructor() {
    this.meetingableId = +(this.activatedRoute.parent?.snapshot.parent?.paramMap.get('id') as string); // This is the company_product id
    this.meetingRecordId = +(this.activatedRoute.snapshot.paramMap.get('meeting_id') as string); // This is the meeting record id
  }

  ngOnInit(): void {}

  canDeactivate(): Observable<boolean> | boolean {
    return this.childComponent.canDeactivate();
  }
}
